<template>
  <MockData class="px-sm" v-if="individStore.individ.data" />
  <div class="h-full p-sm">
    <ArendeManagement
      v-if="individStore.individ.data"
      :individ-id="individStore.individ.data?.id"
    />
  </div>
</template>

<script setup lang="ts">
import MockData from "@/components/mock-data/MockData.vue";
import { useIndividStore } from "@/stores";

import ArendeManagement from "./arende-management/ArendeManagement.vue";

const individStore = useIndividStore();
</script>
